import React from 'react';
import styles from '../styles/loader.module.css';

const Loader = ({ progress }) => {
    return (
        <div className={styles.loaderContainer}>
            <div className={styles.loader}></div>
            <p>Loading... {progress.toFixed(2)}%</p>
        </div>
    );
};

export default Loader;